import React from 'react';
import PropTypes from "prop-types";
import Avatar from '@mui/material/Avatar';
import GameDateTime from './GameDateTime';
import LiveTvIcon from '@mui/icons-material/LiveTv';
const Game = (props) => {

    if (props.item === undefined)
    {
        return '';
    }


    const feed = props.item.hasVideoFeed && (props.item.state === 'Scheduled' || props.item.state === 'OnProgress') ? <div className="game-live"><a href={props.item.videoFeed} target="_blank" rel="noreferrer"><LiveTvIcon fontSize="large" className="news-feed__icon news-feed__icon--live-tv" /></a></div> : '';
    const scoreBox = () => {
        

        switch(props.item.state){
            case 'Scheduled':
                return <div className='game-score'></div>;
            case "Cancelled":
                return <div className='game-score'>Annulé</div>;
            case "Forfeit":
                return <div className='game-score'>
                    <div className='game-score__runs'>{props.item.score.awayRuns}</div>
                    <div className='game-score__inning'>Forfait</div>
                    <div className='game-score__runs'>{props.item.score.homeRuns}</div>
                </div>;
            case "Finished":
                return <div className='game-score'>
                    <div className='game-score__runs'>{props.item.score.awayRuns}</div>
                    <div className='game-score__inning'>{props.item.score.inning}/F</div>
                    <div className='game-score__runs'>{props.item.score.homeRuns}</div>
                </div>;
            case "OnProgress":
                const i = props.item.score.inningState !== 'NotDefined' && props.item.score.inning > 0 ? props.item.score.inning: '';
                return <div className='game-score'>
                    <div className='game-score__runs'>{props.item.score.awayRuns}</div>
                    <div className='game-score__inning'>{i}</div>
                    <div className='game-score__runs'>{props.item.score.homeRuns}</div>
                </div>;
            default:
                return <div></div>;
        }
    };

    return (
        <div key={props.key} className="game">
            <div className='game-location'>{props.item.location}</div>
            <GameDateTime dateClassName="game-date" date={props.item.startDate} />
            <div className='game-box'>
                <Avatar
                    alt={props.item.awayTeam.name}
                    title={props.item.awayTeam.name}
                    src={props.item.awayTeam.image}
                    sx={{ width: { xs:24, sm: 24, md: 36, lg:56, xl:56}, height: { xs:24, sm: 24, md: 36, lg:56, xl:56} }}/>
                {scoreBox()}
                <Avatar
                    alt={props.item.homeTeam.name}
                    title={props.item.homeTeam.name}
                    src={props.item.homeTeam.image}
                    sx={{ width: { xs:24, sm: 24, md: 36, lg:56, xl:56}, height: { xs:24, sm: 24, md: 36, lg:56, xl:56} }}/>
            </div>
           {feed} 
        </div>
    );
}

Game.propTypes = {
    item: PropTypes.object
};

export default Game;